// Generated by `bazel run i18n`. Do not edit by hand.
import pages_e7caf882 from "./en/src--pages.json";
import tabs_a594bf4a from "./en/src--tabs.json";
import src_c1a2d0b5 from "./en/src.json";

export default Object.assign(
  {},
  pages_e7caf882,
  tabs_a594bf4a,
  src_c1a2d0b5,
);
